import CloseIcon from '@/assets/icons/CloseIcon';
import { BasicContainer } from '@/components/Common/BasicContainer/BasicContainer';
import FormItem from '@/components/Common/FormItem/FormItem';
import COLORS from '@/constants/colors';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material';
import { useAssignKamViewController } from './AssignKamViewController';

export function AssignKamDialog(props: {
  open: boolean;
  handleClose: () => void;
}) {
  const { uiState } = useAssignKamViewController();

  return (
    <Dialog fullWidth open={props.open} onClose={props.handleClose}>
      <>
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            background: COLORS.gray_50,
            alignItems: 'center',
          }}
        >
          <Stack>
            <Typography
              sx={{
                fontSize: '18px',
                fontWeight: 600,
                color: COLORS.gray_600,
              }}
            >
              Asignar KAM
            </Typography>
          </Stack>
          <IconButton onClick={props.handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ background: COLORS.gray_50 }}>
          <Stack spacing={'16px'}>
            <BasicContainer
              content={
                <Grid container columnSpacing="20px" p="16px">
                  <FormItem label="Key Account Manager" sx={{ width: '100%' }}>
                    <Select fullWidth displayEmpty value="">
                      <MenuItem value="" disabled>
                        Selecciona un KAM
                      </MenuItem>
                      {uiState.kamList.map((kam) => (
                        <MenuItem key={kam.id} value={kam.id}>
                          {kam.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormItem>
                </Grid>
              }
            />
            <Button variant="contained">Guardar</Button>
          </Stack>
        </DialogContent>
      </>
    </Dialog>
  );
}
